import React, { Component } from "react";

import Img from "react-image";
import { Link } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
import facebookShare from "../img/icons/facebook-whitebg-icon.png";
//Images imports
import twitterShare from "../img/icons/twiter-whitebg-icon.png";

export default class BioItem extends Component {
  render() {
    const { item } = this.props;
    return (
      <div className="row bio-carousel-item">
        <MetaTags>
          <title>Millennials Mafia - {item.title}</title>
          <meta name="description" content="Some description." />
          <meta
            property="og:title"
            content={`Millennials Mafia - ${item.title}`}
          />
          <meta property="og:image" content={item.src} />
        </MetaTags>
        <div className="description d-flex flex-column">
          <div dangerouslySetInnerHTML={{ __html: item.description }} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bio-item.js